import img1 from "../images/cards/tableGame/card-1.jpg";
import img2 from "../images/cards/tableGame/card-2.jpg";
import img3 from "../images/cards/tableGame/card-3.jpg";
import img4 from "../images/cards/tableGame/card-4.jpg";
import img5 from "../images/cards/tableGame/card-5.jpg";
import img6 from "../images/cards/tableGame/card-6.jpg";
import img7 from "../images/cards/tableGame/card-7.jpg";
import img8 from "../images/cards/tableGame/card-8.jpg";
import img9 from "../images/cards/tableGame/card-9.jpg";
import img10 from "../images/cards/tableGame/card-10.jpg";
import img11 from "../images/cards/tableGame/card-11.jpg";
import img12 from "../images/cards/tableGame/card-12.jpg";

export const TableGameDB = [
  {
    title: 'Table games',
    image: img1
  },
  {
    title: 'Table games',
    image: img2
  },
  {
    title: 'Table games',
    image: img3
  },
  {
    title: 'Table games',
    image: img4
  },
  {
    title: 'Table games',
    image: img5
  },
  {
    title: 'Table games',
    image: img6
  },
  {
    title: 'Table games',
    image: img7
  },
  {
    title: 'Table games',
    image: img8
  },
  {
    title: 'Table games',
    image: img9
  },
  {
    title: 'Table games',
    image: img10
  },
  {
    title: 'Table games',
    image: img11
  },
  {
    title: 'Table games',
    image: img12
  },

]